// extracted by mini-css-extract-plugin
export default {"input":"input_input__S0ki9","inputNoFullWidth":"input_inputNoFullWidth__fxBgC"};